<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="sidebarx" spacer v-model="updateTimeKeepingConfig.isOpen" id="update-time-keeping">
        <div class="flex items-center justify-between px-6">
            <h4 class="text-2xl font-bold">Edit Time Keeping</h4>
            <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
            <div class="sidebar-content p-6">
                <div class="info-form mb-base">
                    <h4 class="text-lg font-bold m-0 mb-2">Staff</h4>
                    <vs-input class="w-full" :value="staff_name" disabled></vs-input>
                    <!-- <v-select @input="selectId($event)" :options="staffList" v-model="staff_name" label="name" disabled :clearable="false" /> -->

                    <div class="flex" :class="{'error-date-time': !validDateTime}">
                        <div class="w-1/2 pr-3">
                            <h4 class="text-lg font-bold m-0 mt-6">In</h4>
                            <!-- <datepicker v-model="tk_in_date" class="input-schedule"></datepicker> -->
                            <flat-pickr :config="configdateTimePicker" v-model="tk_in_date" class="input-schedule" />
                        </div>

                        <div class="w-1/2 pl-3">
                            <h4 class="text-lg font-bold m-0 mt-6">Out</h4>
                            <!-- <datepicker v-model="tk_out_date" :disabledDates="disabledDates" class="input-schedule second-datepicker"></datepicker> -->
                            <div class="w-full position-relative">
                                <flat-pickr :config="configdateTimePicker" v-model="tk_out_date" :disabledDates="disabledDates" clearable class="input-schedule second-datepicker" />
                                <feather-icon icon="XIcon" @click.stop="" svgClasses="h-6 w-6" class="cursor-pointer close-datetime-icon" v-if="tk_out_date" @click="tk_out_date = null"></feather-icon>
                            </div>
                        </div>
                    </div>

                    <p class="text-danger text-sm mt-2 d-none error-date-time-text">** Out time must be greater than in time!!</p>

                    <h4 class="text-lg font-bold m-0 mt-6 mb-2">Note</h4>
                    <vs-textarea :maxlength="max_length_note" v-model="tk_note" :counter="max_length_note" :counter-danger.sync="counterDanger" height="150" />

                    <!-- <div class="flex">
                        <div class="w-1/2 pr-3"> -->
                            <h4 class="text-lg font-bold m-0 mt-6">Created at</h4>
                            <datepicker v-model="created_at" class="input-schedule" disabled></datepicker>
                        <!-- </div>

                        <div class="w-1/2 pl-3"> -->
                            <h4 class="text-lg font-bold m-0 mt-6">Updated at</h4>
                            <datepicker v-model="updated_at" class="input-schedule second-datepicker" disabled></datepicker>
                        <!-- </div>
                    </div> -->
                </div>
            </div>
        </VuePerfectScrollbar>
        <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
            <vs-button class="mr-6" @click.stop="updateTimeKeeping" style="min-width: 140px;">Save</vs-button>
            <vs-button type="border" color="danger" @click.stop="closeSidebar" style="min-width: 140px;">Cancel</vs-button>
        </div>
    </vs-sidebar>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment';
export default {
    name: 'update-time-keeping',
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        VuePerfectScrollbar
    },
    props: {
        updateTimeKeepingConfig: {
            type: Object
        },
        updateData: {
            type: Object
        }
    },
    data() {
        return {
            staff_name: this.updateData.staff_name,
            in_date: this.updateData.time_in,
            out_date: this.updateData.time_out,
            in_date_temp: new Date(),
            out_date_temp: new Date(),
            note: this.updateData.note,
            created_at: this.updateData.created_at,
            updated_at: this.updateData.updated_at,
            max_length_note: 160,
            counterDanger: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            selectedId: this.updateData.staff_id,
            disabledDates: {
              to: this.in_date ? new Date(this.in_date.getFullYear(), this.in_date.getMonth(), this.in_date.getDate())
              : new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            },
            configdateTimePicker: {
                enableTime: true,
                // dateFormat: 'Y-m-d 00:00:00'
                // dateFormat: 'Y-m-d H:i'
                // altInput: true,
                dateFormat: "d M Y h:i K",
                // altFormat: "d-M-Y",
                // allowInput: true,
                parseDate: (datestr, format) => {
                    return moment(datestr, format).toDate();
                },
                // formatDate: (date, format, locale) => {
                //     // locale can also be used
                //     return moment(date).format(format);
                // }
            },
            validDateTime: true
        }
    },
    watch: {
      updateTimeKeepingConfig: {
        immediate: true,
        deep: true,
        handler(){
          this.staff_name = this.updateData.staff_name,
          this.in_date = this.updateData.time_in ? new Date(this.updateData.time_in) : new Date(),
          this.out_date = this.updateData.time_out ? new Date(this.updateData.time_out) : null,
          this.note = this.updateData.note;
          this.validDateTime = true;
        }
      },
      in_date: {
        immediate: true,
        deep: true,
        handler(){
          this.in_date_temp = new Date(this.in_date);
          this.out_date_temp = this.out_date ? new Date(this.out_date) : null;
          if(this.out_date_temp && this.in_date_temp){
            if(this.out_date_temp.getTime() < this.in_date_temp.getTime()){
              this.out_date = new Date(this.in_date);
            }
          }
          this.disabledDates.to = new Date(this.in_date_temp.getFullYear(), this.in_date_temp.getMonth(), this.in_date_temp.getDate())
        }
      }
    },
    methods: {
        checkValidDateTime() {
            if(this.in_date && this.out_date) {
                if(new Date(this.in_date) < new Date(this.out_date)) {
                    return true;
                }
            } else {
                if(!this.out_date) {
                    return true;
                }
            }
            return false;
        },
        selectId(e) {
          this.selectedId = e.user_id;
        },
        updateTimeKeeping() {
            this.validDateTime = this.checkValidDateTime();
            if(this.validDateTime) {
                const obj = {
                    id : this.updateData.id,
                    time_in : moment(this.in_date).format('MM/DD/YYYY HH:mm'),
                    // time_out : this.out_date ? moment(this.out_date).format('MM/DD/YYYY HH:mm') : null,
                    note : this.note,
                    "per-page" : 10
                }
                if(this.out_date) {
                    obj.time_out = moment(this.out_date).format('MM/DD/YYYY HH:mm');
                }
                this.$emit("UpdateTimeKeepingData", obj)
            }
        },
        closeSidebar() {
            this.updateTimeKeepingConfig.isOpen = false;
        }
    },
    computed: {
        staffList() {
            return this.$store.getters['staffList/staffList'];
        },
        tk_in_date: {
            get() {
                return this.in_date;
            },
            set(value) {
                this.in_date = value;
            }
        },
        tk_out_date: {
            get() {
                return this.out_date;
            },
            set(value) {
                this.out_date = value;
            }
        },
        tk_note: {
            get() {
                return this.note;
            },
            set(value) {
                this.note = value;
            }
        }
    }
}
</script>
